<template>
  <v-row no-gutters>

      <v-col cols="12" sm="6" md="6">
        <v-checkbox class="shrink mb-2 mt-0" v-model="employee" hide-details  outlined label="Empleado" @change="onChangeEmployee"></v-checkbox>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-checkbox class="shrink mb-2 mt-0" v-model="deliveryFree" hide-details   outlined label="Delivery Bonificado" ></v-checkbox>
      </v-col>

    <v-col cols="12" sm="6" md="6">
      <v-text-field
          dense single-line outlined
          v-model.number="discountRate"
          hide-details
          type="number"
          prepend-inner-icon="percent"
          label="Descuento" placeholder="Descuento %"
          :rules="discountRateRule"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="6">
      <v-text-field
          dense single-line outlined
          v-model.number="discountAmount"
          hide-details
          type="number"
          prepend-inner-icon="attach_money"
          label="Descuento neto" placeholder="Descuento neto"
          :rules="discountAmountRule"
      ></v-text-field>
    </v-col>

  </v-row>
</template>

<script>
export default {
  name: "BarDiscountForm",
  methods: {
    onChangeEmployee(val){
      let discount = null
      if(val){
        discount = this.$store.getters.getSettingValue('EmployeeDiscount')
      }
      this.$store.commit('orderDiscountRate',discount)
    }
  },
  computed: {
    totalAmount(){
      return this.$store.getters.orderSystem.getTotalAmount
    },
    discountRateRule(){
      return [
          v => (!v || v >= 0 && v < 100) || '>0 y <100'
      ]
    },
    discountAmountRule(){
      return [
        v => (!v || v >= 0 && v < this.totalAmount) || 'Mayor al total'
      ]
    },
    discountRate: {
      get() {
        return this.$store.getters.orderSystem.order.discountRate
      },
      set(val) {
        this.$store.commit('orderDiscountRate', val)
      }
    },
    discountAmount: {
      get() {
        return this.$store.getters.orderSystem.order.discountAmount
      },
      set(val) {
        this.$store.commit('orderDiscountAmount', val)
      }
    },
    employee: {
      get() {
        return this.$store.getters.orderSystem.order.employee
      },
      set(val) {
        this.$store.commit('orderEmployee', val)
      }
    },
    deliveryFree: {
      get() {
        return this.$store.getters.orderSystem.order.deliveryFree
      },
      set(val) {
        this.$store.commit('orderDeliveryFree', val)
      }
    }
  }
}
</script>

<style scoped>

</style>
